import { getListOfGatewayAndPriceEmail } from "../types/gateway_and_price_list_email_types";

export const getListOfGatewayAndPriceEmailRequest = (payload, cb) => ({
  type: getListOfGatewayAndPriceEmail.GET_LIST_OF_GATEWAY_AND_PRICE_EMAIL_REQUEST,
  payload,
  cb,
});
export const getListOfGatewayAndPriceEmailSuccess = (payload) => ({
  type: getListOfGatewayAndPriceEmail.GET_LIST_OF_GATEWAY_AND_PRICE_EMAIL_SUCCESS,
  payload,
});
export const getListOfGatewayAndPriceEmailError = (payload) => ({
  type: getListOfGatewayAndPriceEmail.GET_LIST_OF_GATEWAY_AND_PRICE_EMAIL_ERROR,
  payload,
});
